import { render, staticRenderFns } from "./VendeursList.vue?vue&type=template&id=4e3f4a60&scoped=true&"
import script from "./VendeursList.vue?vue&type=script&lang=js&"
export * from "./VendeursList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3f4a60",
  null
  
)

export default component.exports